
const ENVIRONMENT = {
  apiUrl: 'https://scriptly-wizard-7c14c9048571.herokuapp.com/api/v1'
};

export default ENVIRONMENT;